/**
 * Setup all Functions
 */
$(document).ready(function () {
    setupLogoutLink();
    setupVisitLink();
    setupCopyToClipboard();
    setupInternationalToggle();
    setupOtherableDropdowns();
    $(".email_check_success").hide();
    copyButtonRegister();
    initLegacyTooltips();

    // DataTables re-renders rows on every draw; promote any new [data-tooltip]
    // attributes to Bootstrap tooltips after each draw.
    $(document).on('draw.dt init.dt', function () { initLegacyTooltips(); });
});

/**
 * GLOBAL a11y fix for Bootstrap 5 modals.
 *
 * When a modal starts closing, BS5 sets aria-hidden="true" on the modal element
 * while a descendant — or the modal element itself (it carries tabindex="-1")
 * — still holds focus. Chrome now blocks this and logs:
 *   "Blocked aria-hidden on an element because its descendant retained focus."
 * Screen readers also lose the element. The spec's guidance is to move focus
 * out (or use `inert`) BEFORE hiding.
 *
 * `hide.bs.modal` fires at the very start of the hide, before BS applies
 * aria-hidden, so blurring the focused descendant here defuses the warning.
 * Delegated on `document` so it covers EVERY modal app-wide (edit-memo, resume,
 * show-events, forgot-password, …) with no per-modal wiring. BS still restores
 * focus to the triggering element on `hidden.bs.modal`, so keyboard flow is
 * unchanged. `Node.contains` counts the node itself, so a focused modal element
 * is handled too. This supersedes the ad-hoc per-flow blur() calls below.
 */
$(document).on('hide.bs.modal', '.modal', function () {
    var active = document.activeElement;
    if (active && this.contains(active)) {
        active.blur();
    }
});

/**
 * GLOBAL fix for "the modal jumps back to the top" when an overlay opens over an
 * open Bootstrap 5 modal.
 *
 * Overlays that render themselves at the end of <body> (a flatpickr calendar or
 * time picker, a SweetAlert) sit outside the modal element in the DOM. The
 * moment one of them takes focus, Bootstrap's modal focus trap reads it as focus
 * escaping the modal and calls focus() on the modal's first focusable child, the
 * close button in the header. Focusing an element scrolls it into view, so a
 * modal the user had scrolled down (the event role schedule, the billing forms,
 * ...) snaps back to the top the instant they click inside the picker.
 *
 * Bootstrap's trap listens for `focusin` in the bubble phase on `document`, so a
 * capture-phase listener on `document` runs first: stop focus events raised
 * inside one of these overlays from ever reaching it. Scoped to when a modal is
 * actually shown, and only to events originating in the overlay. Neither library
 * relies on this document-level event -- flatpickr binds focus/blur on its own
 * input and mousedown/keydown on document, SWAL drives focus from its popup
 * element -- so nothing else changes.
 */
var FLOATING_OVERLAY_SELECTOR = '.swal2-container, .flatpickr-calendar';

document.addEventListener('focusin', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!document.querySelector('.modal.show')) return;
    if (target.closest(FLOATING_OVERLAY_SELECTOR)) {
        e.stopPropagation();
    }
}, true);

/**
 * Standardize SweetAlert2 to the Inspinia look. Inspinia themes the SWAL popup
 * (see pixel.css `.swal2-*`) but expects real Bootstrap/Inspinia `.btn` buttons
 * rather than SWAL's own solid colored buttons. Apply that as a GLOBAL mixin so
 * every existing `Swal.fire(...)` call across the app inherits it — legacy
 * per-call `confirmButtonColor` options simply become no-ops once
 * `buttonsStyling` is off. (SweetAlert2 loads before global.js, so window.Swal
 * exists here; guarded so legacy pages without SWAL don't error.)
 */
if (window.Swal && typeof window.Swal.mixin === 'function') {
    window.Swal = window.Swal.mixin({
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-primary me-2',
            cancelButton: 'btn btn-light',
            denyButton: 'btn btn-danger me-2',
        },
    });
}

/**
 * Themed confirmation helper for new "are you sure?" prompts so title, icon and
 * buttons stay consistent in one place. Pass `{ danger: true }` for destructive
 * actions (red confirm). Returns the SweetAlert2 promise:
 *   apsConfirm({ text: 'Delete this user?', danger: true })
 *       .then(r => { if (r.isConfirmed) { ... } });
 */
window.apsConfirm = function (opts) {
    opts = opts || {};
    return window.Swal.fire({
        title: opts.title || 'Are you sure?',
        text: opts.text || '',
        icon: opts.icon || 'warning',
        showCancelButton: true,
        confirmButtonText: opts.confirmText || 'Confirm',
        cancelButtonText: opts.cancelText || 'Cancel',
        customClass: {
            confirmButton: 'btn ' + (opts.danger ? 'btn-danger' : 'btn-primary') + ' me-2',
            cancelButton: 'btn btn-light',
        },
    });
};

/**
 * Promote legacy [data-tooltip="..."] attributes to Bootstrap tooltips.
 * Background: dozens of DataTable render functions emit markup like
 *   <a><span class="view-img" data-tooltip="View"></span></a>
 * and the original tooltip was a CSS-only ::before/::after pair on
 * [data-tooltip]. When we swapped the action-icon spans to render Tabler
 * glyphs via ::before, that pseudo became unavailable for the tooltip.
 * This shim moves the value to `title` + `data-bs-toggle="tooltip"` and
 * initializes Bootstrap's tooltip — so the icon glyph and the tooltip
 * coexist without any per-blade markup changes.
 */
window.initLegacyTooltips = function () {
    if (typeof bootstrap === 'undefined' || !bootstrap.Tooltip) return;
    document.querySelectorAll('[data-tooltip]').forEach(function (el) {
        var text = el.getAttribute('data-tooltip');
        if (!text) return;
        el.setAttribute('title', text);
        el.setAttribute('data-bs-toggle', 'tooltip');
        el.setAttribute('data-bs-placement', el.getAttribute('data-bs-placement') || 'top');
        el.removeAttribute('data-tooltip');
        if (!bootstrap.Tooltip.getInstance(el)) {
            new bootstrap.Tooltip(el, {container: 'body', trigger: 'hover'});
        }
    });

    // Initialize statically-rendered Bootstrap tooltips (e.g. the <x-info-tooltip>
    // component, which emits data-bs-toggle="tooltip"). Nothing else inits these,
    // so without this the info/help icons fall back to the raw browser title (and
    // never show our styled tooltip). Respects each element's own data-bs-* config.
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
        if (!bootstrap.Tooltip.getInstance(el)) {
            new bootstrap.Tooltip(el, {container: 'body'});
        }
    });
};

window.copyButtonRegister = function copyButtonRegister() {
    document.querySelectorAll('.copy-icon').forEach(icon => {
        // Guard against double-binding: this runs on every DataTable `draw.dt`,
        // and a page may have several tables each triggering it, so an icon
        // could otherwise accumulate duplicate listeners (and copy twice).
        if (icon.dataset.copyBound === '1') return;
        icon.dataset.copyBound = '1';
        icon.addEventListener('click', function () {
            const textToCopy = this.dataset.copy;
            copyToClipboard(textToCopy)
                .then(() => {
                    notify('success', 'Success!', 'Text copied to clipboard');
                })
                .catch(err => {
                    notify('error', 'Error!', 'Failed to copy text');
                    console.error('Failed to copy text: ', err);
                });
        });
    });
}

// Build an email-cell value with the standard click-to-copy icon appended
// (the /clients pattern). Shared by DataTable render functions across the app
// so every email column shows the same affordance. Returns the value
// unchanged when `email` is falsy (so "no email" placeholders stay plain).
window.emailCopyHtml = function emailCopyHtml(email) {
    if (!email) return email;
    var safe = String(email).replace(/"/g, '&quot;');
    return email + ' <i class="ti ti-copy copy-icon ms-1" role="button" tabindex="0"' +
        ' data-copy="' + safe + '" title="Click to Copy"></i>';
};

// Inspinia-style required validation: required fields turn green live (CSS on
// `.needs-validation`), and the red invalid state only appears after a submit
// attempt. Adding `.was-validated` on submit reveals the red state + any
// `.invalid-feedback`. Non-blocking: the form's own (ajax) submit flow is
// untouched — this only toggles the visual class.
$(document).on('submit', 'form.needs-validation', function () {
    this.classList.add('was-validated');
});

$(document).on('click', '.forgot-password-modal', function () {
    $(".forgot_email").val('');
    $(".email_check_error").html('');
    $(".email_check_success").html('');
    $(".invalid-feedback").hide();
    $(".email_check_success").hide();
});

window.onForgotPasswordCheck = function (response) {
    if (response && response.status == 'error' && response.error) {
        $(".invalid-feedback").show();
        $(".email_check_error").html('');
        $(".email_check_success").html('');
        $(".email_check_success").hide();
        $(".email_check_error").html('<strong>' + response.error + '</strong>');
    }
    if (response && response.status == 'data' && response.data) {
        // If only one account matches, auto-send the reset email without showing the picker.
        if (response.data.length === 1) {
            var only = response.data[0];
            var $form = $('#sendPasswordEmail');
            $form.find('input[name="talent_email"]').remove();
            $form.find('input[name="authuser"]').remove();
            $form.prepend('<input type="hidden" name="talent_email" value="' + only.email + '">');
            $form.prepend('<input type="hidden" name="authuser" value="' + only.user_id + '">');
            $form.trigger('submit');
            $form.find('input[name="talent_email"], input[name="authuser"]').remove();
            return;
        }

        $(".sendEmailUserContent").html('');
        var rowsHtml = '';
        $(response.data).each(function (key, value) {
            var email = $('<div>').text(value.email).html();
            var fullname = $('<div>').text(value.fullname).html();
            var username = $('<div>').text(value.username).html();
            // Pixel-native list-group + form-check radio row. .account-row /
            // .account-radio class hooks are preserved so the existing change
            // handler at the bottom of this file keeps working.
            rowsHtml +=
                '<label class="account-row list-group-item list-group-item-action d-flex align-items-center gap-3" for="account-radio-' + key + '">' +
                    '<input type="radio" class="form-check-input account-radio flex-shrink-0 mt-0" name="authuser" id="account-radio-' + key + '" value="' + value.user_id + '" data-email="' + email + '">' +
                    '<div class="flex-grow-1">' +
                        '<div class="fw-semibold">' + fullname + '</div>' +
                        '<small class="text-muted">Username: ' + username + '</small>' +
                    '</div>' +
                    '<i class="ti ti-check text-primary fs-4 account-check-icon"></i>' +
                '</label>';
        });

        $(".sendEmailUserContent").html(
            '<div class="list-group mb-3">' + rowsHtml + '</div>' +
            '<input type="hidden" name="talent_email" class="talent_email" value="">' +
            '<span class="invalid-feedback email_check_error" role="alert"></span>'
        );
        $("#sendPasswordEmailSubmit").prop('disabled', true);
        // Blur the focused submit button BEFORE hiding the modal so BS5
        // doesn't warn about aria-hidden on a focused descendant.
        if (document.activeElement) { document.activeElement.blur(); }
        $("#forgot-password").modal('hide');
        $("#forgot-password-2").modal('show');
    }
    if (response && response.status == 'success' && response.success) {
        $(".email_check_success").show();
        $(".invalid-feedback").hide();
        $(".email_check_error").html('');
        $(".email_check_success").html('');
        $(".forgot_email").val('');
        $(".email_check_success").html(response.success);
    }
}

// Clicking an account row selects it and enables the Submit button.
$(document).on('change', '.sendEmailUserContent .account-radio', function () {
    var $row = $(this).closest('.account-row');
    $('.sendEmailUserContent .account-row').removeClass('selected');
    $row.addClass('selected');
    $('.sendEmailUserContent .talent_email').val($(this).data('email'));
    $('#sendPasswordEmailSubmit').prop('disabled', false);
});


window.onSendPasswordEmail = function (response) {
    if (response && response.status == 'error' && response.error) {
        notify('error', response.error);
    }
    if (response && response.status == 'success' && response.success) {
        // Blur focused button so BS5 doesn't warn about aria-hidden on
        // a focused descendant when the modal closes.
        if (document.activeElement) { document.activeElement.blur(); }
        // Close both forgot-password modals and surface confirmation via toast.
        $("#forgot-password-2").modal('hide');
        $("#forgot-password").modal('hide');
        $(".forgot_email").val('');
        notify('success', 'Email sent', response.success);
    }
}

$(document).on('keyup', '.forgot_email', function () {
    $(".invalid-feedback").hide();
    $(".email_check_success").hide();
});

/** Setup Dropdowns that Have an Other Option **/
function setupOtherableDropdowns() {
    $('.otherable').change(function () {
        if ($(this).val() == 'Other') {
            if ($(this).data('othertype') == 'modal') {
                $('#' + $(this).data('other')).modal('show');
            } else {
                $('#' + $(this).data('other')).show();
            }
        } else {
            if ($(this).data('othertype') == 'modal') {
                $('#' + $(this).data('other')).modal('hide');
            } else {
                $('#' + $(this).data('other')).hide();
            }
        }
    });
}


/**
 * Inspinia-style Touchspin (number stepper) — document-level delegation.
 *
 * Markup pattern (lifted from Inspinia's form-other-plugin reference):
 *   <div class="input-group" data-touchspin>
 *     <button class="btn btn-light floating" data-minus><i class="ti ti-minus"></i></button>
 *     <input type="number" min="0" max="999999" value="0">
 *     <button class="btn btn-light floating" data-plus><i class="ti ti-plus"></i></button>
 *   </div>
 *
 * Inspinia's own initTouchSpin() in their app.js binds once on
 * DOMContentLoaded, which misses any [data-touchspin] added later (e.g.
 * elements built inside a modal-body before the modal opens). Use
 * delegated click listeners on `document` so it works for every
 * Touchspin instance regardless of when it was inserted.
 *
 * Fires `change` + `input` events after each step so existing per-page
 * handlers (.scheduleTrigger in eventedit, validation in saveRole, etc.)
 * pick up the new value without per-page wiring.
 */
document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-touchspin] [data-minus], [data-touchspin] [data-plus]');
    if (!btn) return;
    var box = btn.closest('[data-touchspin]');
    var input = box && box.querySelector('input');
    if (!input || input.hasAttribute('readonly') || input.disabled) return;
    var isPlus = btn.hasAttribute('data-plus');
    var min = Number(input.min);
    var max = Number(input.max);
    var hasMin = Number.isFinite(min);
    var hasMax = Number.isFinite(max);
    var cur = parseInt(input.value, 10) || 0;
    var next = isPlus ? cur + 1 : cur - 1;
    if (isPlus && hasMax && next > max) return;
    if (!isPlus && hasMin && next < min) return;
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
});


/** Setup CSRF Tokens for All Ajax Requests */
/** Run immediately (not in document.ready) so it's set before any AJAX calls */

// Single source of truth for the CSRF token. Pages historically disagree on the
// meta tag name — some emit <meta name="_token">, others <meta name="csrf-token">.
// Read whichever is present so a page that only declares one still works.
window.csrfToken = function () {
    return (
        document.querySelector('meta[name="_token"]') ||
        document.querySelector('meta[name="csrf-token"]') ||
        {}
    ).content || '';
};

// jQuery: covers every $.ajax / $.post / $.get on the page.
$.ajaxSetup({
    headers: {'X-CSRF-TOKEN': window.csrfToken()}
});

// fetch(): jQuery's ajaxSetup does NOT touch native fetch, so any fetch() POST
// must carry the token itself. Rather than rely on each call site to remember
// (the bulk-action handlers and publicPortfolioRefresh.js are easy to miss),
// wrap window.fetch once so every SAME-ORIGIN, state-changing request gets the
// X-CSRF-TOKEN header automatically. GET/HEAD/OPTIONS and cross-origin requests
// are left untouched (never leak the token off-site); a caller that already set
// the header wins.
(function () {
    if (typeof window.fetch !== 'function' || window.fetch.__csrfWrapped) return;
    var nativeFetch = window.fetch.bind(window);

    function isSameOrigin(url) {
        try {
            // Relative URLs (no scheme/host) are always same-origin.
            return new URL(url, window.location.href).origin === window.location.origin;
        } catch (e) {
            return true;
        }
    }

    var wrapped = function (input, init) {
        init = init || {};
        // Resolve URL + method whether called as fetch(url, init) or fetch(Request).
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = (init.method || (input && input.method) || 'GET').toUpperCase();
        var safe = method === 'GET' || method === 'HEAD' || method === 'OPTIONS';

        if (!safe && isSameOrigin(url)) {
            var headers = new Headers(init.headers || (input && input.headers) || {});
            if (!headers.has('X-CSRF-TOKEN')) {
                headers.set('X-CSRF-TOKEN', window.csrfToken());
            }
            if (!headers.has('X-Requested-With')) {
                headers.set('X-Requested-With', 'XMLHttpRequest');
            }
            init = Object.assign({}, init, { headers: headers });
            if (!('credentials' in init)) init.credentials = 'same-origin';
        }
        return nativeFetch(input, init);
    };
    wrapped.__csrfWrapped = true;
    window.fetch = wrapped;
})();

/** Setup Logout Links */
function setupLogoutLink() {
    $('.logoutlink').click(function (e) {
        e.preventDefault();
        window.removeAvatarImageCookies();
        $('#logoutform').submit();
    });
}

/** Setup Items that Cause a Copy to Clipboard  */
function setupCopyToClipboard() {
    $('.copycontent').click(function () {
        window.copyToClipboard($(this).data('content'))
            .then(function () {
                notify('success', 'Success!', 'Link copied to the clipboard');
            })
            .catch(function () {
                notify('error', 'Error!', 'Could not copy the link');
            });
        closewebsite();
    });
}

function closewebsite() {
    $('.por-web').toggleClass("active");
    $('.por-list').toggleClass("por-show");
    if ($(".por-web.active").is(':visible')) {
        // $(".por-list").removeClass("animation-show");
        // $(".por-list").slideDown("fast");
    } else {
        // $(".por-list").addClass("animation-show");
        // $(".por-list").slideUp("fast");
    }
}

// Mobile sidebar — uses Pixel's built-in `data-sidenav-size="offcanvas"` mode
// (see assets/js/app.js in the Inspinia theme). Below the lg breakpoint we
// flip <html> into offcanvas mode (Pixel CSS then resets the content-page
// margin and pushes the sidebar off-screen). The hamburger toggles the
// `.sidebar-enable` class which Pixel uses to slide the sidebar back in,
// and a backdrop element catches outside clicks to close.
window.adjustSidebarLayout = function () {
    var html = document.documentElement;
    var saved = html.getAttribute('data-sidenav-size-default') || 'default';
    if (window.innerWidth <= 991.98) {
        html.setAttribute('data-sidenav-size', 'offcanvas');
    } else {
        html.setAttribute('data-sidenav-size', saved);
        html.classList.remove('sidebar-enable');
        hideSidebarBackdrop();
    }
};
function showSidebarBackdrop() {
    if (document.getElementById('sidenav-backdrop')) return;
    var bd = document.createElement('div');
    bd.id = 'sidenav-backdrop';
    bd.className = 'offcanvas-backdrop fade show';
    document.body.appendChild(bd);
    bd.addEventListener('click', function () {
        document.documentElement.classList.remove('sidebar-enable');
        hideSidebarBackdrop();
    });
}
function hideSidebarBackdrop() {
    var bd = document.getElementById('sidenav-backdrop');
    if (bd) bd.parentNode.removeChild(bd);
}
$(document).on('click', '.sidenav-toggle-button, .button-close-offcanvas', function (e) {
    e.preventDefault();
    var html = document.documentElement;
    var willOpen = !html.classList.contains('sidebar-enable');
    html.classList.toggle('sidebar-enable');
    if (willOpen && html.getAttribute('data-sidenav-size') === 'offcanvas') {
        showSidebarBackdrop();
    } else {
        hideSidebarBackdrop();
    }
});
// Run once on load + on every resize (matches theme's _adjustLayout pattern).
$(window).on('resize', window.adjustSidebarLayout);
$(window.adjustSidebarLayout);

// ─── Toast notifications — SINGLE source of truth (Toastify-js) ─────────────
// Every toast in the app goes through window.notify(). To restyle ALL toasts on
// a client request (colors, duration, position, …) edit window.NOTIFY_CONFIG
// below — nothing else. Pages MUST NOT redefine notify() locally.
//   notify(type, message, title, opts)
//     type     'success' | 'error' | 'warning' | 'info'
//     message  bold lead line · title  optional detail (rendered "message — title")
//     opts     optional per-call overrides, e.g. { duration: 10000, escapeMarkup: false }
window.NOTIFY_CONFIG = {
    duration: 6000,
    gravity: 'bottom',
    position: 'right',
    close: true,
    stopOnFocus: true,
    // Render HTML in toast text (legacy toastr behavior — server validation
    // messages use <br/> for multi-line errors). Messages are app/server built.
    escapeMarkup: false,
    colors: { success: '#16a34a', error: '#dc2626', warning: '#d97706', info: '#2563eb' },
    defaultColor: '#2563eb'
};
window.notify = function notify(type, message, title, opts) {
    var cfg = window.NOTIFY_CONFIG;
    opts = opts || {};
    Toastify({
        text: title ? (message + ' — ' + title) : message,
        duration: opts.duration != null ? opts.duration : cfg.duration,
        gravity: opts.gravity || cfg.gravity,
        position: opts.position || cfg.position,
        close: opts.close != null ? opts.close : cfg.close,
        stopOnFocus: opts.stopOnFocus != null ? opts.stopOnFocus : cfg.stopOnFocus,
        escapeMarkup: opts.escapeMarkup != null ? opts.escapeMarkup : cfg.escapeMarkup,
        style: { background: opts.background || cfg.colors[type] || cfg.defaultColor }
    }).showToast();
};


/** Setup Items that Cause a Visit to a new Link  */
function setupVisitLink() {
    $('.visitlink').click(function () {
        var win = window.open($(this).data('content'), '_blank');
    });
}

/** Setup the action to toggle intenrational choices on and off */
function setupInternationalToggle() {
    $('.internationalToggleBox').change(function () {
        if (this.checked == true) {
            $('.internationalOptions').removeClass('d-none');
        } else {
            $('.internationalOptions').addClass('d-none');
        }
    });
}

/** Format Date-Time **/
window['formatDateTime'] = function (dt) {
    if (dt != null && dt != 'null') {
        var d = new Date(dt);

        var month = new Intl.DateTimeFormat('en', {month: 'short'}).format(d);
        var day = new Intl.DateTimeFormat('en', {day: 'numeric'}).format(d);
        var year = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(d);
        var hour = new Intl.DateTimeFormat('en', {hour: 'numeric', minute: 'numeric', hour12: true}).format(d);

        return month + ' ' + day + ' ' + year + ' ' + hour;
    } else {
        return null;
    }
}

/** Format Time For Display **/
window['formatTime'] = function (time) {
    if (time != null && time != 'null') {

        var bits = time.split(':');
        hours = bits[0];

        var suffix = ((bits[0] >= 12) ? 'pm' : 'am');
        if (bits[0] > 12) {
            hours = bits[0] - 12;
        }
        if (bits[0] > 24) {
            hours = bits[0] - 24;
        }

        return hours + ':' + bits[1] + ' ' + suffix;
    } else {
        return null;
    }
}


window.removeAvatarImageCookies = function () {
    $.each($.cookie(), function (name, value) {
        if (/^avatarImage/.test(name)) {
            $.removeCookie(name, {path: '/'});
        }
    });
}

window.getImageFullPath = function(media, conversion = null, withFaceParam = true, withBaseUrl = true) {
    let path = media.fullpath;

    if (conversion === 'preview' && media?.preview && media?.preview !== '') {
        path = media.preview;
    } else if (conversion === 'preview_full' && media?.preview_full && media?.preview_full !== '') {
        path = media.preview_full;
    }

    if (media?.importlocation == 1) {
        path = window.getImportedMediaUrl(path);
    }

    let url = withBaseUrl ? 'https://storage.googleapis.com/aps-media/' + path : path;

    if (withFaceParam) {
        url += `?face_center_x=${media?.facecenterx}&face_center_y=${media?.facecentery}`;
    }

    // Cache-busting: append updated_at timestamp so rotated/modified images are not served from cache
    if (media?.updated_at) {
        let separator = url.includes('?') ? '&' : '?';
        url += `${separator}_t=${new Date(media.updated_at).getTime()}`;
    }

    return url;
}

window.getImportedMediaUrl = function (url) {
    let result = url.replace(/talent\//g, "importedMedia/");
    result = result.replace(/\/Image/g, "/BigImage");
    return result;
}


/** Format Date-Time **/
window['formatDate'] = function (dt) {
    if (dt != null && dt != 'null') {
        var d = new Date(dt);

        var month = new Intl.DateTimeFormat('en', {month: 'short'}).format(d);
        var day = new Intl.DateTimeFormat('en', {day: 'numeric'}).format(d);
        var year = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(d);

        return month + ' ' + day + ' ' + year;
    } else {
        return null;
    }
}

/**
 * Copy text to the clipboard.
 *
 * `value` is the text, or a Promise resolving to it for flows where the text is
 * not known until an ajax call (or a confirmation dialog) finishes.
 *
 * Safari only allows a clipboard write while the user gesture that started it is
 * still active, and it does not move the document selection into an input that
 * never took focus. That is why the old "append a temp input, .select(),
 * execCommand('copy')" pattern pasted a single space on macOS Safari while
 * working in every other browser. For the async case the pending promise is
 * handed to `ClipboardItem` (the API WebKit provides for exactly this) so the
 * write is still registered inside the original click.
 *
 * The returned Promise rejects when the copy really failed, so callers must not
 * report success unconditionally.
 */
function copyToClipboard(value) {
    if (value && typeof value.then === 'function') {
        return copyPendingToClipboard(value);
    }
    return copyTextToClipboard(value);
}

window.copyToClipboard = copyToClipboard;

function copyPendingToClipboard(pending) {
    var settled = Promise.resolve(pending);

    if (window.isSecureContext && navigator.clipboard && navigator.clipboard.write &&
        typeof window.ClipboardItem === 'function') {
        var item = null;
        try {
            item = new ClipboardItem({
                'text/plain': settled.then(function (text) {
                    return new Blob([normalizeClipboardText(text)], {type: 'text/plain'});
                })
            });
        } catch (error) {
            item = null;
        }
        if (item) {
            return navigator.clipboard.write([item]).catch(function () {
                // Browsers that refuse a promise-backed item can still copy
                // once the text itself is known.
                return settled.then(copyTextToClipboard);
            });
        }
    }

    return settled.then(copyTextToClipboard);
}

function normalizeClipboardText(text) {
    return (text === null || text === undefined) ? '' : String(text);
}

function copyTextToClipboard(value) {
    var text = normalizeClipboardText(value);

    if (!text) {
        return Promise.reject(new Error('Nothing to copy'));
    }
    // Navigator clipboard api needs a secure context (https)
    if (window.isSecureContext && navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(function () {
            return legacyCopyToClipboard(text);
        });
    }
    return legacyCopyToClipboard(text);
}

/** execCommand fallback for insecure contexts (plain-http dev) and old browsers. */
function legacyCopyToClipboard(text) {
    var previouslyFocused = document.activeElement;
    var textArea = document.createElement('textarea');

    textArea.value = text;
    textArea.setAttribute('readonly', 'readonly');
    // Kept inside the viewport but invisible: Safari will not select the
    // contents of an element that has been moved off screen.
    textArea.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;' +
        'border:none;outline:none;box-shadow:none;background:transparent;opacity:0;font-size:16px;';
    document.body.appendChild(textArea);

    var copied = false;
    try {
        // execCommand copies the *document* selection, so the field has to hold
        // focus as well as be selected, or Safari copies nothing.
        textArea.focus();
        textArea.select();
        textArea.setSelectionRange(0, text.length);
        copied = document.execCommand('copy');
    } catch (error) {
        copied = false;
    }

    textArea.remove();
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
    }

    return copied ? Promise.resolve() : Promise.reject(new Error('Clipboard copy was blocked'));
}

/**
 * Reduce a server error body to something safe to put in a toast.
 *
 * Toasts render with `escapeMarkup: false` (server validation messages rely on
 * `<br/>`), so an upload that fails *upstream of Laravel* is a problem: the
 * proxy answers with a full HTML document, not JSON, and injecting that into
 * the toast renders its `<h1>`/`<h2>` at heading size. Cloud Run does exactly
 * this — it caps a single request at 32 MiB and returns its own
 * "413 Request Entity Too Large" page before PHP ever sees the upload.
 *
 * Plain strings (including the `<br/>` ones) are passed through untouched.
 */
function summarizeUploadError(raw, status) {
    if (!/<\s*(!doctype|html|head|body|h[1-6])\b/i.test(raw)) {
        return raw.trim();
    }

    // DOMParser is inert: no scripts run, no subresources load.
    var doc = new DOMParser().parseFromString(raw, 'text/html');
    var summary = (
        doc.querySelector('title')?.textContent ||
        doc.querySelector('h1')?.textContent ||
        doc.body?.textContent ||
        ''
    ).replace(/\s+/g, ' ').trim();

    if (summary.length > 140) {
        summary = summary.slice(0, 140).trim() + '\u2026';
    }
    return summary || ('The upload failed' + (status ? ' (HTTP ' + status + ')' : '') + '.');
}

/**
 * "File Too Large" toast. Talent get the extra line linking to the support
 * article that walks through compressing a video (support/talent.blade.php,
 * `#video-upload-help`); other roles have no such page.
 */
function notifyFileTooLarge(detail) {
    var userRole = document.querySelector('meta[name="user-role"]')?.getAttribute('content') || '';
    var help = userRole === 'Talent'
        ? ' <a href="/support#video-upload-help" target="_blank" style="color:#fff;text-decoration:underline;">Learn how to reduce your video file size.</a>'
        : '';

    if (typeof notify === 'function') {
        notify('error', 'File Too Large', detail + help, { duration: 10000 });
    } else {
        alert('File Too Large: ' + detail);
    }
}

window.DropZoneErrorHandler = function DropZoneErrorHandler(response, xhr) {
    var errorMessage = typeof response === 'string' ? response : (response?.message || '');
    var status = (xhr && xhr.status) || 0;

    // Two ways an upload can be rejected for size, and both must land on the
    // same friendly toast:
    //   1. Dropzone's own `maxFilesize` check, client side.
    //   2. HTTP 413 from whatever sits in front of PHP. On the Cloud Run web
    //      tier that fires at 32 MiB, well under Dropzone's 256 MB, so this is
    //      the branch talent actually hit.
    if (errorMessage.indexOf('File is too big') === 0) {
        notifyFileTooLarge('The limit for uploads is 256MB. Please ensure your file is 256MB or less.');
        return;
    }
    if (status === 413 || /(entity|content) too large/i.test(errorMessage)) {
        notifyFileTooLarge('This file is too large for the server to accept. Please compress it and try again.');
        return;
    }

    // show error
    var message = summarizeUploadError(errorMessage, status) || 'An error occurred while uploading the file.';
    if (typeof notify === 'function') {
        notify('error', 'Error!', message);
    } else {
        alert('Error: ' + message);
    }
}

/**
 * flatpickr helpers (replace the old date-range + time pickers).
 *
 * Centralizes the AgencyPro date/time picker conventions so every field looks
 * and behaves the same across the app:
 *   - US `m/d/Y` display format,
 *   - `" - "` range separator (kept identical to the old date-range picker
 *     output so backend parsing of "MM/DD/YYYY - MM/DD/YYYY" is unchanged),
 *   - an optional clear (×) button appended after the input, replacing the
 *     "Clear" cancel button the old date-range picker used to render.
 *
 * Usage:
 *   fpDate('#expires', { minDate: 'today', clearable: true });
 *   fpRange('#datebetween', { maxDate: 'today', onApply: () => table.draw() });
 */
window.fpClearButton = function (instance) {
    var input = instance.altInput || instance.input;
    if (!input) return;

    // Put the input + × inside a Bootstrap .input-group so the button sits
    // flush at the input's right edge instead of wrapping to the next line
    // under a block-level input. Build the wrapper in JS so no blade markup
    // changes are needed and dynamically-rendered fields are covered too.
    var group = input.closest('.input-group');
    if (!group) {
        group = document.createElement('div');
        group.className = 'input-group fp-clear-group';
        // Inputs with a compact inline width (filter fields) should stay
        // compact — keep the group inline-auto and carry their width over.
        if (input.style.width === 'auto' || input.style.minWidth) {
            group.classList.add('fp-clear-group--auto');
            if (input.style.minWidth) group.style.minWidth = input.style.minWidth;
        }
        input.style.width = '';
        input.style.minWidth = '';
        input.insertAdjacentElement('beforebegin', group);
        group.appendChild(input);
    }

    // Drop any stale button (re-init) so the new one closes over the new
    // flatpickr instance, then append a fresh × addon.
    var stale = group.querySelector('.fp-clear');
    if (stale) stale.remove();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fp-clear input-group-text';
    btn.setAttribute('aria-label', 'Clear date');
    // Literal × glyph (not an icon font) so it renders on both the Pixel layout
    // (Tabler icons) and the legacy app layout (Font Awesome 4).
    btn.innerHTML = '&times;';
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        instance.clear(); // fires onChange, so any onApply/redraw runs too
    });
    group.appendChild(btn);
    return btn;
};

// The old date-range picker accepted moment objects for start/min/max dates;
// flatpickr wants a Date / parseable string. Normalize so callers can pass a
// dayjs object (or moment), a Date, or a string interchangeably (covers the
// mixed call styles in the pages migrated off the old picker).
function fpNormDate(v) {
    if (Array.isArray(v)) return v.map(fpNormDate);
    if (v && typeof v === 'object' && typeof v.toDate === 'function') return v.toDate();
    return v;
}

function fpNormalizeOpts(opts) {
    ['defaultDate', 'minDate', 'maxDate'].forEach(function (k) {
        if (opts[k] !== undefined) opts[k] = fpNormDate(opts[k]);
    });
    return opts;
}

// flatpickr's internal `selectedDates` is the source of truth for what the
// picker shows. Edit forms that fill a field with jQuery `.val()` (e.g. the
// bookout time inputs, populated from server data) never tell flatpickr about
// that value — so the next time the field is opened the picker renders its
// default (12:00 AM for a time picker) and writes that back, wiping the real
// value. Adopt any pre-set input value on open so the picker reflects it.
// Registered as a global default: it applies to every flatpickr instance that
// doesn't define its own onOpen (none of ours do), covering raw flatpickr()
// callers (bookout) and the fpDate/fpRange helpers alike.
if (typeof flatpickr !== 'undefined') {
    flatpickr.setDefaults({
        onOpen: function (selectedDates, dateStr, instance) {
            if (instance.selectedDates.length) return;      // flatpickr already knows the value
            if (instance.config.mode === 'range') return;   // range strings don't single-parse
            var el = instance.input;
            var val = el && el.value ? el.value.trim() : '';
            if (!val) return;
            var parsed = instance.parseDate(val, instance.config.dateFormat);
            if (parsed) instance.setDate(parsed, false);     // false: don't fire onChange
        },
    });
}

// Populate a flatpickr TIME picker from a 24h "HH:MM" / "HH:MM:SS" string.
// Goes through flatpickr's setDate so the picker's internal selectedDates is
// correct — clicking the field then shows the real time instead of resetting to
// the default (12:00). The displayed text follows the picker's own dateFormat,
// so callers do NOT need to pre-format the string to match (avoids the bug where
// a "14:35" or "2:35 PM" value that doesn't match the picker format gets wiped).
// Falls back to a plain value set if the element isn't a flatpickr instance.
window.fpSetTime = function (selector, hms) {
    if (hms === undefined || hms === null || hms === '') return;
    var el = document.querySelector(selector);
    if (!el) return;
    var parts = String(hms).split(':');
    var h = parseInt(parts[0], 10) || 0;
    var m = parseInt(parts[1], 10) || 0;
    if (el._flatpickr) {
        var d = new Date();
        d.setHours(h, m, 0, 0);
        el._flatpickr.setDate(d, false); // false: don't fire onChange
    } else {
        el.value = hms;
    }
};

// Destroy any flatpickr already bound to the matched elements so a re-init
// (dynamic forms, ajax-refreshed rows) doesn't stack duplicate calendars.
window.fpDestroy = function (selector) {
    if (typeof selector !== 'string') return;
    document.querySelectorAll(selector).forEach(function (el) {
        if (el._flatpickr) el._flatpickr.destroy();
    });
};

window.fpDate = function (selector, opts) {
    opts = Object.assign({}, opts);
    var clearable = opts.clearable;
    delete opts.clearable;
    var config = fpNormalizeOpts(Object.assign({ dateFormat: 'm/d/Y' }, opts));
    window.fpDestroy(selector);
    var instances = flatpickr(selector, config);
    if (clearable) {
        [].concat(instances).forEach(function (inst) { window.fpClearButton(inst); });
    }
    return instances;
};

// ---------------------------------------------------------------------------
// glightbox (replaces Lightbox2). A single delegated `a.glightbox` opener that
// mirrors Lightbox2's old body-delegated anchor click handler, so
// galleries built dynamically (event registrations, portfolio carousels) work
// without re-initialising. Group via `data-gallery`; full image URL in `href`;
// caption from `data-title`. Reuses one instance to avoid leaking DOM.
window.openGlightbox = function ($clicked) {
    if (typeof GLightbox === 'undefined') return;
    var group = $clicked.data('gallery') || '';
    var clickedHref = $clicked.attr('href');
    var $group = group
        ? $('a.glightbox[data-gallery="' + group + '"]')
        : $clicked;
    var elements = [];
    var startAt = 0;
    $group.each(function (i) {
        var href = $(this).attr('href');
        if (href === clickedHref) startAt = i;
        elements.push({ href: href, type: 'image', title: $(this).data('title') || '' });
    });
    if (!elements.length) return;
    if (window.__glb) { try { window.__glb.destroy(); } catch (e) {} }
    window.__glb = GLightbox({ elements: elements, startAt: startAt });
    window.__glb.open();
};

$(document).on('click', 'a.glightbox', function (e) {
    e.preventDefault();
    window.openGlightbox($(this));
});

window.fpRange = function (selector, opts) {
    opts = Object.assign({}, opts);
    var clearable = opts.clearable !== false; // ranges are clearable by default
    delete opts.clearable;
    var onApply = opts.onApply;
    delete opts.onApply;
    var userOnChange = opts.onChange;
    delete opts.onChange;
    var userOnClose = opts.onClose;
    delete opts.onClose;
    var userOnValueUpdate = opts.onValueUpdate;
    delete opts.onValueUpdate;
    var userOnReady = opts.onReady;
    delete opts.onReady;
    var config = fpNormalizeOpts(Object.assign({
        mode: 'range',
        dateFormat: 'm/d/Y',
        locale: { rangeSeparator: ' - ' },
    }, opts));
    // flatpickr's range formatter drops duplicate dates, so a start == end
    // range renders as a single bare "m/d/Y" no matter how it was set.
    // Consumers that split on " - " then read `undefined` as the end date, and
    // length-based "is a range set?" checks fail outright. Rewrite the field to
    // the full two-sided string whenever both ends are known.
    //
    // Hooked on three events because no single one covers every path: onReady
    // for the initial `defaultDate` (init calls updateValue(false), which
    // suppresses onValueUpdate), onValueUpdate for calendar clicks, and
    // onChange for programmatic setDate(..., true).
    var restoreRange = function (selectedDates, instance) {
        if (!instance || !instance.input || selectedDates.length !== 2) return;
        var joined = selectedDates.map(function (d) {
            return instance.formatDate(d, instance.config.dateFormat);
        }).join(instance.l10n.rangeSeparator);
        if (instance.input.value !== joined) instance.input.value = joined;
    };
    config.onChange = function (selectedDates, dateStr, instance) {
        restoreRange(selectedDates, instance);
        if (typeof userOnChange === 'function') userOnChange(selectedDates, dateStr, instance);
        // Fire onApply once a full range is chosen, or when the field is cleared.
        if (typeof onApply === 'function' && (selectedDates.length === 2 || selectedDates.length === 0)) {
            onApply(selectedDates, instance);
        }
    };
    // Picking a single day leaves the range half-open. Every consumer of these
    // fields (and the backend parsers) expects the "start - end" shape the old
    // date-range picker always emitted, so close a lone pick into a same-day
    // range; restoreRange above then writes both halves out.
    config.onClose = function (selectedDates, dateStr, instance) {
        if (typeof userOnClose === 'function') userOnClose(selectedDates, dateStr, instance);
        if (selectedDates.length === 1) {
            instance.setDate([selectedDates[0], selectedDates[0]], true);
        }
    };
    config.onReady = function (selectedDates, dateStr, instance) {
        if (typeof userOnReady === 'function') userOnReady(selectedDates, dateStr, instance);
        restoreRange(selectedDates, instance);
    };
    config.onValueUpdate = function (selectedDates, dateStr, instance) {
        if (typeof userOnValueUpdate === 'function') userOnValueUpdate(selectedDates, dateStr, instance);
        restoreRange(selectedDates, instance);
    };
    window.fpDestroy(selector);
    var instances = flatpickr(selector, config);
    if (clearable) {
        [].concat(instances).forEach(function (inst) { window.fpClearButton(inst); });
    }
    return instances;
};
